import { Link } from 'react-router-dom';
import { siteConfig, categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-heading font-semibold text-foreground-900 mb-4">{siteConfig.name}</h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {siteConfig.description}。致力于为爱美女性提供最专业的白丝穿搭建议和时尚资讯。
            </p>
          </div>

          <div>
            <h4 className="text-lg font-heading font-semibold text-foreground-900 mb-4">热门分类</h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-heading font-semibold text-foreground-900 mb-4">快速链接</h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">首页</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">关于我们</Link>
              </li>
              <li>
                <Link to="/category/product-review" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">产品评测</Link>
              </li>
              <li>
                <Link to="/category/care-tips" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">保养技巧</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-heading font-semibold text-foreground-900 mb-4">联系我们</h4>
            <ul className="flex flex-col gap-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                <span>{siteConfig.email}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-500"></i>
                <span>{siteConfig.phone}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-primary-500"></i>
                <span>{siteConfig.wechat}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-500"></i>
                <span className="leading-relaxed">{siteConfig.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteConfig.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-primary-600 transition-colors duration-200" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-600 transition-colors duration-200" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-600 transition-colors duration-200" aria-label="小红书">
              <i className="ri-red-packet-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}